import { CUSTOM_DASHBOARD_INTERNAL_TYPES } from '@linearb/linjs-common';
import { Menu, MenuItem } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { BookDemoTooltip } from '@linearb/linui-common';
import { navigateBookDemoClick } from 'common/utils/utils';
import {
  CTA_TOOLTIP_TEXTS,
  TRACKING
} from '../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING as TRACKING_EVENTS } from 'common/constants/constants';

const TitleWrapper = styled(Flex)`
  padding-left: 1.5rem;
  padding-bottom: 6px;
  padding-top: 6px;
`;
const DashboardSelectorMenu = ({ anchorEl, onSelect, setAnchorEl }) => {
  const { isAllControbutorsTeamSelected } = useDoraFeatureFlags();
  const isTeamLicense = useSelector(isTeamLicenseSelector);

  const clickAndTrackBookDemo = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
      page: TRACKING_EVENTS.PAGES.METRICS,
      cta: TRACKING.CTA_TYPE.BUTTON,
      intent: TRACKING.CTA_INTENT.BOOK_A_DEMO,
      source_url: window.location.href
    });
    navigateBookDemoClick();
  };

  const bookDemoTooltipProps = {
    message: CTA_TOOLTIP_TEXTS.METRICS_DASHBOARD_SELECTOR,
    buttonText: CTA_TOOLTIP_TEXTS.BOOK_A_DEMO,
    disabled: !isTeamLicense || !isAllControbutorsTeamSelected,
    onClick: clickAndTrackBookDemo
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl(null)}
    >
      <TitleWrapper>
        <Text size='medium' color='shuttleGray'>
          CREATE A NEW REPORT:
        </Text>
      </TitleWrapper>

      <MenuItem onClick={() => onSelect()}>
        <Text size='medium' pb='0.2rem' pt='0.2rem'>
          Pre-Defined Metrics Report
        </Text>
      </MenuItem>

      <BookDemoTooltip {...bookDemoTooltipProps}>
        <div data-testid='tooltip-data-test-id'>
          <MenuItem
            data-testid='menu-item-data-test-id'
            disabled={isAllControbutorsTeamSelected}
            onClick={() =>
              onSelect(CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS)
            }
          >
            <Text size='medium' pb='0.2rem' pt='0.2rem'>
              Custom Report
            </Text>
          </MenuItem>
        </div>
      </BookDemoTooltip>
    </Menu>
  );
};

export default DashboardSelectorMenu;
